import React from 'react';
import PropTypes from 'prop-types';
import Button from 'components/button/ActionButton';
import { ImageIcon } from 'assets/materialIcons/materialIcons';
import translate from 'components/hoc/translate';
import theme from 'theme/theme';

const AmendButton = (props) => {
    const {
        onClick,
        translate,
    } = props;

    return (
        <Button
            icon={ <ImageIcon color={ theme.palette.doveGray }/> }
            title={ translate('actions.edit') }
            primary={ false }
            onClick={ onClick }
        />
    );
};

AmendButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
};

export default translate(AmendButton);



// WEBPACK FOOTER //
// ./src/components/button/AmendButton.js